
import React, { useState } from 'react';
import { Paper, InfoTooltip, InputAddon, Button } from '../components';
import { compose, lifecycle, shouldUpdate } from 'recompose';
import { connect } from 'react-redux';
import {
  SchoolDashboardNavContainer, SchoolDashboardHeadingContainer,
  HeaderContainer, SchoolGeneralIntelligenceProgressContainer,
  DataDisplayGeneralSchoolContainer,
  SchoolGeneralCoursesProgressContainer,
  PageTitleContainer
} from '../containers'; 
import { Col, Row, Modal } from 'reactstrap';
import Translations from '../hocs/TranslationsHelper'; 

import { PdfData } from '../../pdfer/Pdfable';
import { SchoolReportPdf } from '../pdfview/SchoolView';
import { withRouter } from 'react-router';
import LessonPlansContainer from '../containers/activity-bank/LessonPlansContainer';
import LessonPlanDataContainer, { ExpandedPdf2 } from '../containers/activity-bank/LessonPlanDataContainer';
import {ExpandedPdf} from '../containers/activity-bank/LessonPlanDataContainer';
import FilterBarContainer from '../containers/activity-bank/FilterBar';
import { push } from 'react-router-redux';
import { SearchInput } from '../components';
import tutorials from '../../data/tutorials_es'
import topScroll from '../hocs/topScroll';
 
import downloadIcon from "../../img/icon_download.svg";
import imgHome from '../../img/academia/banner_welcome.png'
import imgPlatform from '../../img/academia/banner_course_1.png'
import imgClassroom from '../../img/academia/banner_course_2.png'
import imgFAQ from '../../img/academia/banner_course_3.png'
import { SimpleToolTip } from '../containers/activity-bank/SimpleToolTip';

const sections = {
    "home": {
        title: "Bienvenido",
        short_title: "Inicio",
        desc: "Aquí podrás participar en los cursos de inducción sobre la plataforma PleIQ School Caligrafix. Conocerás a profundidad las funcionalidades de tu Escuela 4.0.",  
        img_url: imgHome 
    },
    "platatforma_educativa": {
        title: "Plataforma Educativa PleIQ School Caligrafix",
        short_title: "Plataforma Educativa",
        desc: "Conoce sobre la plataforma educativa PleIQ School Caligrafix, aprende de las funcionalidades y secciones que la conforman, características generales de su uso e implementación en la escuela.",
        desc2: "¡Bienvenido! En este curso podrás conocer sobre la plataforma educativa PleIQ School Caligrafix, ver las funcionalidades y secciones que la conforman, características generales de su uso e implementación en la escuela.",
        pdf_url: "https://pleiqpro.s3.us-east-1.amazonaws.com/Assets/Academy/pdf/plataforma_educativa_pleiq_school_caligrafix.pdf",
        img_url: imgPlatform,
        items: [ 
            {
                title: "Introducción a PleIQ School Caligrafix",
                pdf_url: "https://pleiqpro.s3.us-east-1.amazonaws.com/Assets/Academy/pdf/plataforma/p00_introduccion_pleiq_school_caligrafix.pdf"
            },
            {
                title: "Perfiles en la plataforma",
                pdf_url: "https://pleiqpro.s3.us-east-1.amazonaws.com/Assets/Academy/pdf/plataforma/p01_perfiles_plataforma.pdf"
            },
            {
                title: "Acceso la plataforma",
                pdf_url: "https://pleiqpro.s3.us-east-1.amazonaws.com/Assets/Academy/pdf/plataforma/p02_acceso_plataforma.pdf"
            },
            {
                title: "Sección Cursos",
                pdf_url: "https://pleiqpro.s3.us-east-1.amazonaws.com/Assets/Academy/pdf/plataforma/p03_seccion_cursos.pdf"
            },
            {
                title: "Sección Caligrafix",
                pdf_url: "https://pleiqpro.s3.us-east-1.amazonaws.com/Assets/Academy/pdf/plataforma/p04_seccion_caligrafix.pdf"
            },
            {
                title: "Sección Inteligencias",
                pdf_url: "https://pleiqpro.s3.us-east-1.amazonaws.com/Assets/Academy/pdf/plataforma/p05_seccion_inteligencias.pdf"
            },
            {
                title: "Sección Informes de Progreso",
                pdf_url: "https://pleiqpro.s3.us-east-1.amazonaws.com/Assets/Academy/pdf/plataforma/p06_seccion_informes_de_progreso.pdf"
            },
            {
                title: "Sección de Planificaciones y Orientaciones",
                pdf_url: "https://pleiqpro.s3.us-east-1.amazonaws.com/Assets/Academy/pdf/plataforma/p07_seccion_de_planificaciones_orientaciones.pdf"
            },
            {
                title: "Sección Mi asistente IA Educativa",
                pdf_url: "https://pleiqpro.s3.us-east-1.amazonaws.com/Assets/Academy/pdf/plataforma/p08_seccion_mi_asistente_ia_educativa.pdf"
            },
            {
                title: "Sección Competencias",
                pdf_url: "https://pleiqpro.s3.us-east-1.amazonaws.com/Assets/Academy/pdf/plataforma/p09_seccion_competencias.pdf"
            },
            {
                title: "Sección Perfiles",
                pdf_url: "https://pleiqpro.s3.us-east-1.amazonaws.com/Assets/Academy/pdf/plataforma/p10_seccion_perfiles.pdf"
            },
            {
                title: "Modo Gratis y Premium de la plataforma",
                pdf_url: "https://pleiqpro.s3.us-east-1.amazonaws.com/Assets/Academy/pdf/plataforma/p11_seccion_modo_gratis_y_premium_plataforma.pdf"
            }
        ]
    },
    "aula_inteligente":{
        title: "Aula Inteligente 4.0 Caligrafix + PleIQ",
        short_title: "Aula Inteligente 4.0",
        desc: "Prepara tu aula para el uso de PleIQ School Caligrafix, aprende sobre el uso de la app PleIQ en tu aula de clases y conviértela en un aula inteligente 4.0.",
        desc2: "Es hora de preparar tu aula inteligente 4.0, conoce aspectos relacionados al uso de la app PleIQ en el aula de clase.",
        pdf_url: "https://pleiqpro.s3.us-east-1.amazonaws.com/Assets/Academy/pdf/aula_Inteligente_caligrafix_pleiq.pdf",
        img_url: imgClassroom,
        items: [ 
            {
                title: "Realidad Aumentada Caligrafix+PleIQ",
                pdf_url: "https://pleiqpro.s3.us-east-1.amazonaws.com/Assets/Academy/pdf/aula-4.0/p00_realidad_aumentada_caligrafix_pleiq.pdf"
            },
            {
                title: "Instalar la App de PleIQ",
                pdf_url: "https://pleiqpro.s3.us-east-1.amazonaws.com/Assets/Academy/pdf/aula-4.0/p01_instalar_app_pleIQ.pdf"
            },
            {
                title: "Interfaz en la vista cámara",
                pdf_url: "https://pleiqpro.s3.us-east-1.amazonaws.com/Assets/Academy/pdf/aula-4.0/p02_interfaz_vista_camara.pdf"
            },
            {
                title: "Seleccionar el perfil del estudiante",
                pdf_url: "https://pleiqpro.s3.us-east-1.amazonaws.com/Assets/Academy/pdf/aula-4.0/p03_seleccionar_el_perfil_del_estudiante.pdf"
            },
            {
                title: "Cambiar de idioma en la App de PleIQ",
                pdf_url: "https://pleiqpro.s3.us-east-1.amazonaws.com/Assets/Academy/pdf/aula-4.0/p04_cambiar_de_idioma_en_la_app_pleiq.pdf"
            },
            {
                title: "Cambiar cuenta personal a la cuenta school",
                pdf_url: "https://pleiqpro.s3.us-east-1.amazonaws.com/Assets/Academy/pdf/aula-4.0/p05_cambiar_cuenta_personal_a_la_cuenta_school.pdf"
            },
            {
                title: "Trabajar con la APP sin conexión a internet",
                pdf_url: "https://pleiqpro.s3.us-east-1.amazonaws.com/Assets/Academy/pdf/aula-4.0/p06_trabajar_con_la_app_sin_conexio╠ün_a_ainternet.pdf"
            },
            {
                title: "Ingresar a la plataforma web PleIQ School Caligrafix",
                pdf_url: "https://pleiqpro.s3.us-east-1.amazonaws.com/Assets/Academy/pdf/aula-4.0/p07_ingresar_a_la_plataforma_web_pleiq_school_caligrafix.pdf"
            },
            {
                title: "Ver progreso del estudiante",
                pdf_url: "https://pleiqpro.s3.us-east-1.amazonaws.com/Assets/Academy/pdf/aula-4.0/p08_ver_progreso_del_estudiante.pdf"
            }  
        ]

    },
    "faq": {
        title: "Preguntas frecuentes",
        short_title: "Preguntas frecuentes",
        desc: "Encuentra respuesta a tu duda en las preguntas más frecuentes hechas por la comunidad. Sobre cuentas y perfiles, creación de la escuela, uso de la app PleIQ entre otros.",
        desc2: "Encuentra respuesta a tu duda aquí, sino escríbenos a soporte@pleiq.com.",
        pdf_url: "https://pleiqpro.s3.us-east-1.amazonaws.com/Assets/Academy/pdf/preguntas_frecuentes_pleiq_school_caligrafix.pdf",
        img_url: imgFAQ ,
        items: [  
        ]

    }  
}

const AcademiaCard =({ title, desc, img_url,  translations, link})=>{
    return <div>
            
            <div  class="d-flex justify-content-center container-fluid"  > 
                <a class="w-75" href={link}>
                    <img class="w-100 h-auto" src={img_url}/>
                </a>    
            </div>
            <br/>
            <h5>{title}</h5>
            <p style={{marginBottom: "0px"}}>{desc}</p>
            <br/>
        </div>;
}
const AcademiaLink =({ title, desc, img_url,  translations})=>{
    return <a> <dib>
            <img src={img_url}/>
            <h5>{title}</h5>
            <p>{desc}</p>
        </dib>
    </a>;
}
const AcademiaHomeView = ({translations})=>{
    return <div> 
        {

            Object.entries(sections).map(([id, data])=>(
                <AcademiaCard translations={translations}
                title={data.title}
                desc={data.desc}
                img_url={data.img_url}
                link={(id == "home")?undefined: "/academia/" + id}/>
            ))
        }
    </div>;
}

const PdfDialog = ({url, onClose,translations })=>{
    const [page, setPage] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    return <div className="ab-pdf"> 

      <div className="ab-pdf"> 
        <div className="ab-pdf-back" onClick={(e)=>{e.stopPropagation();e.preventDefault();onClose();}}></div>
        <div className="rcr">
          <div className="ab-pdf-rect">
            <div className="ab-pdf-rect-header"> 
              <a className="ab-pdf-rect-header-dbutton" id={"header-dbutton" } href={url}  target="_blank" download onClick={(e)=>{e.stopPropagation()}}>
                <img src={downloadIcon}/>
                <SimpleToolTip text={translations.t("ab_download_tooltip")} target={"header-dbutton" } />
              </a>
           {/*    <div className="ab-pdf-rect-header-nav">

                <div className="ab-pdf-rect-header-nav-button" onClick={()=>{if(page>1) setPage(page-1);}}>
                  <span
                    className="pleiq-icon-icon_arrow_left"
                  />
                </div>
                <div className="ab-pdf-rect-header-nav-page">
                  {page}/{pageCount}
                </div>
                <div className="ab-pdf-rect-header-nav-button" onClick={()=>{if(page < pageCount )setPage(page+1);}}> 
                  <span
                    className="pleiq-icon-icon_arrow_right"
                  />
                </div> 

              </div> */}
              <button className="ab-pdf-rect-header-dbutton" onClick={onClose}>X</button>
            </div>
            <div className="ab-pdf-rect-content">
                <ExpandedPdf2 className="ab-pdf-rect-content-pdf" pdf_uri={url} npages={pageCount}  onLoadSuccess={({ numPages })=>{setPageCount(numPages); }}/> 
            </div>
            
          {  
            } 
          </div>           
        </div>

      </div>
    </div>;
    
}
const AcademiaSectionView = ({translations, id})=>{
    const { title, desc2, items, img_url, pdf_url} = sections[id];
    const [currentPdf, setCurrentPdf] = useState(null);
    return <Col> 
            <AcademiaCard translations={translations} title={title}
            desc={desc2}
            img_url = {img_url}/> 
            <div class="d-flex justify-content-center"> 
                <Button type="primary--blue"    
                                onClick={
                                ()=>window.open(pdf_url, '_blank').focus()}>
                    Descargar Contenido Completo
                </Button>   
            </div>
            <br/>
            <ul>
            {
                items.map(({title, pdf_url})=>(
                    <li> 
                    <a onClick={(e)=>{
                        e.preventDefault();
                        e.stopPropagation();
                        setCurrentPdf(pdf_url);
                    }} href={pdf_url}>{title}</a>
                    </li>
                ))
            } 
            </ul>
         { currentPdf && <PdfDialog url={currentPdf} translations={translations} onClose={()=>setCurrentPdf(null)}/> }
    </Col>;
}


var categories = [... new Set(tutorials.map(({category})=> category))] 
/**
 * screen for the school Progress
 *
 * @method ActivityBank
 *
 */
const Academia = ({ translations, match,location, dispatch }) => {
  topScroll();
  const { params } = match;
  const { page } = params;
  
 
  //<input type="text" value={search} onChange={(e)=>{dispatch(push(`/lesson_plans/${page}?search=${encodeURIComponent(e.target.value)}&&filter=${encodeURIComponent(filter)}`))}} placeholder="search"/>  
              

  return (
    <div id="school-dashboard" className=" layout-base">
      <PageTitleContainer pageTitle={"ac_"+page+"_title"} />
      <HeaderContainer />
      <SchoolDashboardHeadingContainer /> 
      <Paper.Container lead >
        <Row>
          <Col xs="12">
            <Paper.Title>
              <h1 style={{marginBottom:"0px"}}>{ 'Academia' }</h1>
            </Paper.Title> 
          </Col> 
          <Col xs="12"> 
        <div className="school-nav paper-nav d-flex justify-content-left align-items-center" style={{marginBottom:"0px"}}> 
            {
              Object.entries(sections).map(([id, data])=>(

                <Paper.NavItem
                  key={id}
                  onClick={() => {dispatch(push(`/academia/${id}`))} }
                  active={id === page}   
                  label={data.short_title}
                  hideLabelSm
                /> 

              ))

            }  
        </div>
          </Col> 
          <Col xs="12"> 
            <Paper.Content> 
              <br/>
              {
                (page == 'home')?
                    (<AcademiaHomeView translations={translations}/>)
                    :(<AcademiaSectionView id={page} translations={translations}/>) 
              }  
            </Paper.Content> 
          </Col>
        </Row>
      </Paper.Container>
 
    </div>
  );
};

export default connect(()=>({}), (dispatch)=>({dispatch}))(Translations(withRouter(  
  
    Academia 
)));
